import { createContext } from 'react';

export const DocumentServicesContext = createContext(null);
DocumentServicesContext.displayName = 'DocumentServicesContext';
